module.exports = __webpack_public_path__ + "img/b-3.905b1cb.png";